import { deserialize as oldDeserialize } from 'deserialize-json-api'

type TDeserializedDoc = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  relationships: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  links: any
}

export function deserialize(json: unknown): TDeserializedDoc {
  return oldDeserialize(json, { transformKeys: 'camelCase' })
}
